import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AdminDrawer from '../components/admin/drawer';
import AccountIcon from '../../src/assets/account_profile.svg'
import { useSelector } from 'react-redux';
export default function AdminLayout({ children }) {
	const loginUserName = useSelector(state => state.auth.loginUserName);
	const [isPopperVisible, setIsPopperVisisble] = useState(false);

	return (
		<div className="admin-full-wrap">
			<AdminDrawer />
			<div className="user-profile-wrapper">
				<a role="button" onClick={() => setIsPopperVisisble(!isPopperVisible)} className="user-profile color-black cursor-pointer">
					<img src={AccountIcon} alt="user" className="user-image" />
					{loginUserName || ''}
				</a>
                {isPopperVisible && (
					<div className="items-holder logout-button-wrapper">
						<a className="logout-button" href="/logout" >
							<span
								className="material-symbols-rounded"
								aria-hidden="true">
								logout</span>
							<span>Log Out</span></a>
                    </div>
                )}
			</div>
			{children}
		</div>
	);
}

AdminLayout.propTypes = {
	children: PropTypes.any,
};
